<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'OccuranceList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Occurance
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Occurance</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Occurance">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label class="control-label">Device MAC</label>
                      <input
                        type="text"
                        id="Device_MAC"
                        name="Device_MAC"
                        v-model="value.Device_MAC"
                        class="form-control Device_MAC"
                        placeholder="Device MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Type</label>
                      <input
                        type="text"
                        id="type"
                        name="type"
                        v-model="value.type"
                        class="form-control type"
                        placeholder="Type"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Host</label>
                      <input
                        type="text"
                        id="destination_hosts"
                        name="destination_hosts"
                        v-model="value.destination_hosts"
                        class="form-control destination_hosts"
                        placeholder="Host"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Message</label>
                      <input
                        type="text"
                        id="Message"
                        name="Message"
                        v-model="value.Message"
                        class="form-control Message"
                        placeholder="Message"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Time</label>
                      <input
                        type="text"
                        id="Time"
                        name="Time"
                        v-model="value.Time"
                        class="form-control Time"
                        placeholder="Time"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Audra MAC</label>
                      <input
                        type="text"
                        id="apmac"
                        name="apmac"
                        v-model="value.apmac"
                        class="form-control apmac"
                        placeholder="Audra MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group required">
                      <label class="control-label">ACC ID</label>
                      <input
                        type="text"
                        id="accountId"
                        name="accountId"
                        v-bind:class="{ 'has-error': errors.has('accountId') }"
                        v-validate="'required'"
                        v-model="value.accountId"
                        class="form-control accountId"
                        placeholder="ACC ID"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('accountId')"
                      >
                        {{ errors.first('accountId') }}
                      </div>
                    </div>
                    <div class="col-md-6 form-group required">
                      <label class="control-label">IS Notified</label>
                      <input
                        type="text"
                        id="is_notified"
                        name="is_notified"
                        v-bind:class="{
                          'has-error': errors.has('is_notified')
                        }"
                        v-validate="'required'"
                        v-model="value.is_notified"
                        class="form-control is_notified"
                        placeholder="IS Notified"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('is_notified')"
                      >
                        {{ errors.first('is_notified') }}
                      </div>
                    </div>
                    <div class="col-md-12 form-group required">
                      <label class="control-label">USER ID</label>
                      <input
                        type="text"
                        id="userid"
                        name="userid"
                        v-bind:class="{ 'has-error': errors.has('userid') }"
                        v-validate="'required'"
                        v-model="value.userid"
                        class="form-control userid"
                        placeholder="USER ID"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('userid')"
                      >
                        {{ errors.first('userid') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import LocalStorage from "@/services/localStorage";

export default {
  name: 'OccuranceForm',
  metaInfo: {
    title: 'Occurance | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/occurances'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/occurances/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'OccuranceList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/occurances/' + id
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(errors => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          })
      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
